export default "__VITE_ASSET__15eaf2a3__"